import { get } from 'lodash'

import { isDevEnvironment } from 'core/environments'

export const getRewardName = reward =>
  get(reward, 'suggestion.name') ?? get(reward, 'name', '')

export const getRewardDescription = reward =>
  get(reward, 'suggestion.description') ?? get(reward, 'description', '')

export const shouldDisableRewardRedeem = company => {
  if (!isDevEnvironment && company?.id === 496) return true
  return false
}

/**
 * The `rewards_carlton_catalogs` endpoint proxies a third-party catalog API
 * and answers 200 even when that API fails, so the payload is sometimes an
 * error object (`{ error: { code, message } }`) instead of the expected list.
 * Anything that is not an array collapses to an empty list, so callers can
 * rely on the declared `any[]` type instead of crashing on `.map`.
 */
export const toRewardsCatalogList = (response: any): any[] =>
  Array.isArray(response) ? response : []
